import React from "react";
import { connect } from "react-redux";
import {
  pullCampaignOffices,
  updateCampaignAggregates,
} from "../../store/api/calls";
import { setAssignedSites, setAssignedTurfs, setDashboardParams, setSessionVar } from "../../store/actions";
import NavBaseTemplate from "../templates/NavBaseTemplate";
import DataTable from "../theme/tables/DataTable";
import DataTableWModal from "../theme/tables/DataTableWModal";
import FromToDatePickerInput from "../theme/forms/FromToDatePickerInput";
import Moment from "moment";
import { startCase } from "lodash";
import FeedbackTile from "../theme/modals/FeedbackTile";
import DashboardOfficeSelector from "../theme/dashboard/selectors/DashboardOfficeSelector";
import DashTabs from "../theme/menus/DashTabs";
import { pullAssignedSites, pullAssignedTurfs } from "../../store/api/calls";
import ImageViewBox from "../imgs/imageViewBox";

class HomeScreen extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      aggregated_campaign: null,
      aggregated_offices: null,
      aggregated_canvassers: null,
      selected_office: 0,
    };

    this.SUBMIT_DATE_FORMAT = "YYYY-MM-DD";
    this.updateInterval = [];
  }

  setDatesToToday = () => {
    this.handleDateChange(new Date(), new Date());
  };

  handleDateChange = (start, end) => {
    this.props.setDashboardParams({
      start: start.getTime(),
      end: end.getTime(),
    });
  };

  componentDidMount() {
    if (!this.props.dashboardParams.start || !this.props.dashboardParams.end) {
      this.setDatesToToday();
    }
    pullCampaignOffices();
    this._setUpdateLoop();
    this.props.setDashboardParams({
      selectedCanvasser: 0
    });
  }

  componentWillUnmount() {
    this.clearAll();
  }

  /** clearAll()
   *  - clear any window/global based timer ids that we have stored.
  ***/
  clearAll() {
    this.updateInterval.forEach((id) => {
      clearInterval(id);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.focusedCampaign.id !== this.props.focusedCampaign.id) {
      this.setState({ selected_office: 0 });
    }
    if (
      prevProps.focusedCampaign.id !== this.props.focusedCampaign.id ||
      prevProps.dashboardParams.start !== this.props.dashboardParams.start ||
      prevProps.dashboardParams.end !== this.props.dashboardParams.end
    ) {
      this._setUpdateLoop();      
      console.log("START", this.props.dashboardParams.start);
    }
  }

  _setUpdateLoop = () => {
    // clear before calling again to avoid multiple network calls.
    this.clearAll();
    this.getAssignments()
    this._updateCampaignAggregates();    
  

    this.updateInterval.push(
      setInterval(() => this._updateCampaignAggregates(), 60 * 4 * 1000)
    );
  };

  _updateCampaignAggregates = () => {
    updateCampaignAggregates(
      Moment(this.props.dashboardParams.start).format(this.SUBMIT_DATE_FORMAT),
      Moment(this.props.dashboardParams.end).format(this.SUBMIT_DATE_FORMAT)
    );
  };

  getAssignments = () => {
    if (this.props.dashboardParams.start != this.props.dashboardParams.end) {
      this.props.setAssignedTurfs([]);
      this.props.setAssignedSites([]);
    } else {
      let start = Moment(this.props.dashboardParams.start).format(
        this.SUBMIT_DATE_FORMAT
      );
      pullAssignedSites({ date: start })
      pullAssignedTurfs({ date: start })
    }
  };

  _startIsToday = () =>
    new Date(this.props.dashboardParams.start).toDateString() ===
    new Date().toDateString();
  _canvasserHasDistanceAlarm = (cdata) =>
    (cdata?.yards_from_target || 0) > 500 && this._startIsToday();
  _canvasserHasTimeAlarm = (cdata) =>
    (cdata?.minutes_since_event || 0) > 25 && this._startIsToday();

  _filterKeysForCanvasserDataTable() {
    let canvassers = this.props.aggregates.canvassers || [];

    if (+this.props.dashboardParams.selectedOffice) {
      canvassers = canvassers.filter(
        (c) => c.office_id === +this.props.dashboardParams.selectedOffice
      );
    }

    let show_site_metrics = canvassers.some((d) => d.num_sites_checked_into);
    let show_door_metrics = canvassers.some((d) => d.num_people_canvassed);

    if (!canvassers.length) return [{ no_data: "--" }];

    return canvassers.map((d) => {
      let matching_assigned_sites =this.props.dashboardParams.assignedSites.find(
          (a) => a.canvasser_id === d.canvasser_id
        );
      let matching_assigned_turfs = this.props.dashboardParams.assignedTurfs.find(
          (a) => a.canvasser_id === d.canvasser_id
        );

      let _o = {
        first_name: startCase(d.firstname),
        _first_name: d.firstname.toLowerCase(),
        last_name: (
          <span>
            {startCase(d.lastname)}
            <span className={"ml-2 is-bold primary-milligram-text"}>
              {d.currently_training_in_field
                ? `TRAINING: ${d.currently_training_in_field}`
                : null}
            </span>
          </span>
        ),
        _last_name: d.lastname.toLowerCase(),
        office: d.office_name,
        num_response: d.num_response,
        last_response: d.last_response ? (
          <span
            className={
              this._canvasserHasTimeAlarm(d) ? "danger-text is-semibold" : ""
            }
          >
            {new Moment(d.last_response).format(
              "MM/DD LT"
            )}
            {this._canvasserHasTimeAlarm(d)
              ? ` (${new Moment.utc().diff(
                  new Moment.utc(d.last_response_utc),
                  "minutes"
                )} min)`
              : null}
          </span>
        ) : (
          "--"
        ),
        _last_response:
          d.last_response === 0 ? new Moment(d.last_response).unix() : 0,
        yards_from_target: d.yards_from_target ? (
          <span
            className={
              this._canvasserHasDistanceAlarm(d)
                ? "danger-text is-semibold"
                : ""
            }
          >
            {d.yards_from_target >= 0 ? d.yards_from_target : 0}
          </span>
        ) : (
          "--"
        ),
        _yards_from_target: d.yards_from_target >= 0 ? d.yards_from_target : 0,
        _data: d,
        _rowStyle: {
          backgroundColor:
            this._canvasserHasTimeAlarm(d) || this._canvasserHasDistanceAlarm(d)
              ? "rgba(188, 64, 64, 0.12)"
              : null,
        },
      };

      if (show_site_metrics) {
        _o = {
          ..._o,
          num_check_ins: d.num_checkins,
          num_sites_checked_into: d.num_sites_checked_into,
          site_contact_attempts: d.num_site_contact_attempts,
          last_site_contact_attempt_time: d.last_response
            ? new Moment(d.last_site_contact_attempt_time).format("MM/DD LT")
            : "--",
          site: d.checked_into_site_name,
          checked_in_at: d.checked_in_time
            ? new Moment(d.checked_in_time).format("MM/DD LT")
            : "--",
          _last_site_contact_attempt_time:
            d.last_site_contact_attempt_time === 0
              ? new Moment(d.last_site_contact_attempt_time).unix()
              : 0,
        };
      }
      if (show_door_metrics) {
        _o = {
          ..._o,
          last_knock: d.last_door_attempt_time
            ? new Moment(d.last_door_attempt_time).format(
                "MM/DD LT"
              )
            : "--",
          _last_knock:
            d.last_door_attempt_time === 0
              ? new Moment(d.last_door_attempt_time).unix()
              : 0,
          num_people_canvassed: d.num_people_canvassed,
          num_households_canvassed: d.num_households_canvassed,
        };
      }

      if (matching_assigned_sites) {
        _o = {
          ..._o,
          crew: matching_assigned_sites.crew_id,
          goal: matching_assigned_sites.goal,
        };
      }

      if (matching_assigned_turfs) {
        _o = {
          ..._o,
          crew: matching_assigned_turfs.crew_id,
          assigned_households: matching_assigned_turfs.targethouseholds.length,
        };
      }

      return _o;
    });
  }

  _filterKeysForCampaign() {
    let data = this.props.aggregates.campaign || [];

    let show_site_metrics = data.some((d) => d.num_checkins);
    let show_door_metrics = data.some((d) => d.num_people_canvassed);

    if (!data.length) return [{ no_data: "--" }];

    return data.map((d) => {
      let _o = {
        name: (this.props.campaigns.find((c) => c.id === d.id) || {}).name,
        num_response: d.num_response,
        canvasser_count: d.canvasser_count,
        _data: d,
      };

      if (show_site_metrics) {
        _o = {
          ..._o,
          num_check_ins: d.num_checkins,
          site_contact_attempts: d.num_site_contact_attempts,
        };
      }
      if (show_door_metrics) {
        _o = {
          ..._o,
          num_people_canvassed: d.num_people_canvassed,
          num_households_canvassed: d.num_households_canvassed,
        };
      }

      return _o;
    });
  }

  _filterKeysForOffices() {
    let data = !+this.props.dashboardParams.selectedOffice
      ? this.props.aggregates.offices || []
      : (this.props.aggregates.offices || []).filter(
          (d) => d.id === +this.props.dashboardParams.selectedOffice
        );

    let show_site_metrics = data.some((d) => d.num_checkins);
    let show_door_metrics = data.some((d) => d.num_people_canvassed);

    if (!data.length) return [{ no_data: "--" }];

    return data.map((d) => {
      let _o = {
        name: d.name,
        num_response: d.num_response,
        canvasser_count: d.canvasser_count,
        _data: d,
      };

      if (show_site_metrics) {
        _o = {
          ..._o,
          num_check_ins: d.num_checkins,
          site_contact_attempts: d.num_site_contact_attempts,
        };
      }
      if (show_door_metrics) {
        _o = {
          ..._o,
          num_people_canvassed: d.num_people_canvassed,
          num_households_canvassed: d.num_households_canvassed,
        };
      }

      return _o;
    });
  }

  render() {
    return (
      <NavBaseTemplate>
        <DashTabs />
        <h3 className={"primary-text"}>Activity Counts</h3>
        <div className="button-table-top-wrapper">
          <FromToDatePickerInput
            handleDateChange={this.handleDateChange}
            from={new Date(this.props.dashboardParams.start)}
            to={new Date(this.props.dashboardParams.end)}
            isloading={this.props.aggregates_loading}
          />

          {/*<div className="box-select-wrapper">*/}
          {/*	<select className="box-selector"*/}
          {/*		onChange={(e) => this.setState({selected_office: e.target.value})}>*/}
          {/*		<option key="0" value={0}>Full Campaign</option>*/}
          {/*		{(this.props.aggregates.offices || []).map((office) => <option key={office.id} value={office.id}>{office.name}</option>)}*/}
          {/*	</select>*/}
          {/*</div>*/}

          <DashboardOfficeSelector />
        </div>

        {!+this.props.dashboardParams.selectedOffice && (
          <DataTable
            isUpdating
            data={this._filterKeysForCampaign()}
            title="Campaign"
          />
        )}

        <DataTable
          isUpdating
          data={this._filterKeysForOffices()}
          title="Offices"
        />

        <DataTableWModal
          events_modal={true}
          events_modal_from={new Date(this.props.dashboardParams.start)}
          events_modal_to={new Date(this.props.dashboardParams.end)}
          data={this._filterKeysForCanvasserDataTable()}
          title="Canvassers"
        />

        <FeedbackTile
          text={
            <div>
              <i
                className=" fas fa-asterisk fa-spin"
                style={{ marginRight: "15px" }}
              />
              Loading...
            </div>
          }
          visible={this.props.aggregates_loading}
        />

        {/*use feedback tile icon, text, state*/}
        <FeedbackTile
          text={
            <div>
              <i
                className="fas fa-exclamation-triangle"
                style={{ marginRight: "15px" }}
              />
              There was a server error.
            </div>
          }
          visible={this.props.aggregates_error}
          backgroundColor={"red"}
        />

        <ImageViewBox />
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  aggregates: state.aggregates.data,
  aggregates_loading: state.aggregates.loading,
  aggregates_error: state.aggregates.error,
  campaigns: state.campaigns?.data,
  focusedCampaign: state.session.focusedCampaign,
  is_admin: state.permissions.is_admin,
  dashboardParams: state.dashboardParams,
  sessionVars: state.session.vars,
  assignedSites: state.assignedSites,
  assignedTurfs: state.assignedTurfs,
});

const mapDispatchToProps = (dispatch) => ({
  setDashboardParams: (data) => dispatch(setDashboardParams(data)),
  setSessionVar: (key, value) => dispatch(setSessionVar(key, value)),
  setAssignedSites: (data) => dispatch(setAssignedSites(data)),
  setAssignedTurfs: (data) => dispatch(setAssignedTurfs(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeScreen);
